import React from "react";
import {
  makeStyles,
  IconButton,
  List,
  Divider,
  ListItem,
  ListItemText,
  Paper,
  Fab,
  Typography,
} from "@material-ui/core";
import SwipableDrawer from "@material-ui/core/SwipeableDrawer";
import MenuIcon from "@material-ui/icons/Menu";
import { withRouter } from "react-router";
import logo from "../../../logo.png";
import {getState} from "../../../controllers/stateController";

const useStyles = makeStyles((theme) => ({
  paper: {
    background: theme.palette.primary.main,
    maxWidth: 225,
    width: "100%",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  list: {
    width: 300,
  },
  fullList: {
    width: "auto",
  },
  active: {
    "&:hover": {
      background: theme.palette.secondary.main,
    },
    backgroundColor: theme.palette.secondary.main,
  },
  buttonDiv: {
    display: "flex",
  },
  fab: {
    margin: theme.spacing(2),
    padding: "11px 0px"
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
  },
  logo: {
    margin: theme.spacing(1),
    marginBottom: 0
  }
}));

const UserTab = ({ leaveSession, user }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const username = "Hello, " + getState().username + "!";
  const roomcode = "Room Code: " + getState().room_code;

  const list = () => (
    <div className={classes.flex}>
      <div>
        <img alt={"Music By Vote"} src={logo} className={classes.logo}/>
        <Divider />
        <List>
          {[username, roomcode, `${user.available_reqs} requests available`].map((text, index) => (
            <ListItem key={text}>
              <ListItemText style={{ color: "#191616" }} primary={text} />
            </ListItem>
          ))}
        </List>
        <Divider />
      </div>
      <Fab
        id="leave-session"
        variant="extended"
        size="large"
        aria-label="leave"
        className={classes.fab}
        color="secondary"
        onClick={() => leaveSession()}
      >
        <Typography>Leave Session</Typography>
      </Fab>
    </div>
  );
  return (
    <div>
      <IconButton onClick={() => setOpen(true)}>
        <MenuIcon />
      </IconButton>
      <Paper>
        <SwipableDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          classes={{
            paper: classes.paper,
          }}
        >
          {list()}
        </SwipableDrawer>
      </Paper>
    </div>
  );
};
export default withRouter(UserTab);
